<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">Copyright © 2017 by Marcus Wicker</p>
<div class="timebreak "> </div>
<p class="center "><span class="smallcaps">ALL RIGHTS RESERVED</span></p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center ">Library of Congress Cataloging-in-Publication Data</p>
<p class="center ">Names: Wicker, Marcus, author.</p>
<p class="center ">Title: Silencer / Marcus Wicker.</p>
<p class="center ">Description: Boston : Mariner Books, 2017. | Description based on print version record and CIP data provided by publisher; resource not viewed. Identifiers: LCCN 2017014165 (print) | LCCN 2017016611 (ebook) | <span class="smallcaps">ISBN</span> 9781328715586 (ebook) | <span class="smallcaps">ISBN</span> 9781328715548 (paperback)</p>
<p class="center ">Subjects: | BISAC: POETRY / American / African American. | POETRY / Inspirational &amp; Religious. | POETRY / American / General. | HISTORY / Social History. | SOCIAL SCIENCE / Black Studies (Global).</p>
<p class="center ">Classification: LCC PS3623.I268 (ebook) | LCC PS3623.I268 A6 2017 (print) | DDC 811/.6—dc23</p>
<p class="center ">LC record available at <a href="https://lccn.loc.gov/2017014165" target="_blank">https://lccn.loc.gov/2017014165</a></p>
<div class="timebreak "> </div>
<p class="center ">Book design by Mark R. Robinson</p>
<div class="timebreak "> </div>
<p class="center ">v1.0817</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?5c3aacf2